module.exports = __webpack_public_path__ + "img/selected_section_strip.b0abb92d.svg";